import { LoggerProvider } from '@opentelemetry/sdk-logs';
import { internal, TRACE_PARENT_HEADER } from '@opentelemetry/core';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import Event from '../shared/Event';
import { getResources } from '../resources';

export class Module {
  constructor(aggregator, config, otelConfig) {
    this.aggregator = aggregator;
    this.config = config;
    this.otelConfig = otelConfig;
    this.exporter = new OTLPLogExporter({
      url: this.config.url,
      headers: this.config.headers,
      compression: this.config.compression,
    });
    this.loggerProvider = new LoggerProvider({
      resource: getResources(
        { ...this.config.resources, ...this.otelConfig.resources },
        this.aggregator.getSharedContext(),
        TRACE_PARENT_HEADER,
      ),
    });
    this.aggregator.addInternal(internal);
    this.aggregator.addExporter('default', this.exporter);
    this.loggerProvider.addLogRecordProcessor(this.aggregator);
    this.event = new Event({ loggerProvider: this.loggerProvider });
  }

  recordEvent(event, exporter = 'default') {
    this.aggregator.setSelectedExporter(exporter);
    this.event.emit(event);
    this.aggregator.setSelectedExporter('default');
  }

  recordLog(record, exporter = 'default') {
    this.aggregator.setSelectedExporter(exporter);
    this.event.log(record);
    this.aggregator.setSelectedExporter('default');
  }

  attachLogExporter(name, config) {
    const exporter = new OTLPLogExporter(config);

    this.aggregator.addExporter(name, exporter);
  }
}
